import { RESOURCE_NAME } from '@esentai/core/features/beacons/consts';
import { canRead } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

export const canReadBeacons = authorizeIf(canRead(RESOURCE_NAME));
